import { graphql } from 'src/graphql';

export const DeleteSession = graphql(`
  mutation deleteSession($booking_id: ID!, $session_id: ID!) {
    deleteSession(booking_id: $booking_id, session_id: $session_id) {
      _id
      session {
        _id
        start
        end
        slot_min
        slot_max
        status
        _researcher_user_id
        ResearcherUser {
          _id
          name
        }
      }
    }
  }
`);
